
import { Component, Mixins } from 'vue-property-decorator';
import SettingsSelect from '@/features/settings/components/SettingsSelect.vue';
import Overview from '@/features/settings/components/notifications/Overview.vue';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';

@Component({
  components: {
    Shipments: () => import('@/features/settings/components/notifications/content/Shipments.vue'),
    Packages: () => import('@/features/settings/components/notifications/content/Packages.vue'),
    ServiceLevelAndPricing: () => import('@/features/settings/components/notifications/content/ServiceLevelAndPricing.vue'),
    Customs: () => import('@/features/settings/components/notifications/content/Customs.vue'),
    PickupOrDropOff: () => import('@/features/settings/components/notifications/content/PickupOrDropOff.vue'),
    General: () => import('@/features/settings/components/notifications/content/General.vue'),
    SettingsSelect,
    Overview,
  },
})
export default class Settings extends Mixins(ResponsivenessMixin) {
  private tabComponents = {
    shipments: 'Shipments',
    packages: 'Packages',
    serviceLevelAndPricing: 'ServiceLevelAndPricing',
    customs: 'Customs',
    pickupOrDropOff: 'PickupOrDropOff',
    general: 'General',
  }

  get routeQuery(): string {
    return this.$route.query.content as string;
  }

  get showOverview(): boolean {
    return this.isTablet && this.routeQuery === 'shipments';
  }
}
